import type { NDateLocale } from './enUS'
import { zhCN } from 'date-fns/locale'

const dateZhCN: NDateLocale = {
  name: 'zh-CN',
  locale: zhCN
}

export default dateZhCN
